import { Component, AfterViewInit, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import Amplify from '@aws-amplify/core';
import { AuthService } from 'src/core/services/auth.service';
import { NavigationEnd, Router } from "@angular/router";
import { UtilsService } from 'src/core/services/utils.service';
import { CognitoUserInterface } from '@aws-amplify/ui-components';
import { PORTAL_DASHBOARD_ROLES } from 'src/core/config/portal-route-roles';

Amplify.configure({
  Auth: environment.auth
});


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'magalies-pharma';
  init: boolean = false;
  is_dark = false;

  // for side nav
  fixedTopGap: number = 0;

  currentUser: CognitoUserInterface | null = null;
  currentRoles: string[] = [];
  showAccountDetails: boolean = false;
  style: string = ""

  constructor(
    private _auth: AuthService,
    private _router: Router,
    private location: Location,
    private utils: UtilsService
  ) { }


  async ngOnInit() {

    this.init = await this._auth.authenticateUser();

    this
      ._auth
      .currentUserChanges()
      .subscribe((user) => {
        this.currentUser = user;
        if (this.currentUser) {
          const roles = this._auth.getRoles();
          // Customers use another site — do not deep-link into portal routes (guard signs them out).
          if (roles.includes('Customer')) {
            return;
          }
          if (this.location.path() === '/portal') {
            const canOpenDashboard = roles.some((r) =>
              PORTAL_DASHBOARD_ROLES.includes(r)
            );
            this._router.navigate([
              canOpenDashboard ? '/portal/dashboard' : '/portal/prescriptions',
            ]);
          }
        }
      });

    this
      ._auth
      .currentRolesChanges()
      .subscribe((roles) => {
        this.currentRoles = roles;
      });

    this
      .utils
      .onMainNavHeightChanged()
      .subscribe(height => {
        this.fixedTopGap = height;
        this.style = `margin-top: ${this.fixedTopGap + 10}px`;
      });

    this._router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
  }
  async signOut() {
    await this._auth.signOut();
  }


  getFirstLetterOfName(user: CognitoUserInterface | null) {
    if (!user) return ":/";
    return user.attributes.name[0];
  }

  autoCloseAccountDetails() {
    this.showAccountDetails = false;
  }
}
